/* eslint-disable no-console */
import React from 'react';
import { Theme } from '@theme';
import { WithCoreProps, TranslationProps } from 'ff-shared-components-core';
import { EntityDataConfirmationScreen, RegisterUserDataDetails } from '@screens';
import { StoreState } from '@store';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export interface SubmitContractScreenProps {
	onClickNext(data: any): void;
	onClickBack(data: any): void;
	onClickCancel: () => void;
}

export interface SubmitContractScreenState {
	userId: any;
	isViewingUserDetail: boolean;
	isViewingEntityData: boolean;
}

interface SubmitContractScreenInjectedProps extends TranslationProps {
	a: Theme;
}

type Props = SubmitContractScreenProps & SubmitContractScreenInjectedProps;

class SubmitContractScreen extends React.PureComponent<Props, SubmitContractScreenState> {
	public constructor(props: Props) {
		super(props);
		this.state = { userId: '', isViewingEntityData: true, isViewingUserDetail: false };
	}
	private onClickBackSubmitContract = (): void => {
		this.setState({ ...this.state, userId: '', isViewingEntityData: true, isViewingUserDetail: false });
	};

	private onClickToViewUserDetail = (row?: any): void => {
		this.setState({
			...this.state,
			isViewingEntityData: false,
			isViewingUserDetail: true,
			userId: row ? row.id : '',
		});
	};

	public render(): JSX.Element {
		const { userId, isViewingEntityData, isViewingUserDetail } = this.state;
		const { onClickBack, onClickNext, onClickCancel } = this.props;

		return (
			<>
				{isViewingEntityData ? (
					<EntityDataConfirmationScreen
						onClickBack={onClickBack}
						onClickNext={onClickNext}
						onClickCancel={onClickCancel}
						canEditUsers={false}
						onClickToViewUserDetail={this.onClickToViewUserDetail}
					/>
				) : (
					''
				)}
				{isViewingUserDetail ? (
					<RegisterUserDataDetails onClickBack={this.onClickBackSubmitContract} userId={userId} />
				) : (
					''
				)}
			</>
		);
	}
}

const mapStateToProps = (state: StoreState): object => ({});
const mapDispatchToProps = (dispatch: any): object => bindActionCreators({}, dispatch);

export default WithCoreProps<SubmitContractScreenProps>(
	connect(mapStateToProps, mapDispatchToProps)(SubmitContractScreen)
);
